import React from 'react';

export default function Sidebar({ tabs, activeTab, onSelect }) {
  return (
    <aside className="hidden md:block w-64 h-[calc(100vh-56px)] border-r border-gray-200 bg-white sticky top-14">
      <nav className="p-3 space-y-1">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => onSelect(t.key)}
            className={`w-full text-left px-3 py-2 rounded-md transition-colors ${
              activeTab === t.key
                ? 'bg-gray-900 text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
            aria-current={activeTab === t.key ? 'page' : undefined}
          >
            {t.label}
          </button>
        ))}
      </nav>
    </aside>
  );
}
